// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.w_nWk9LsUxEoG4X2EABG{border:1px solid var(--black-10);background:var(--yellow-20);color:var(--yellow-100);border-radius:4px;height:16px;margin-top:7px;padding:2px;font-size:10px;font-weight:500;display:inline-flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"status": `w_nWk9LsUxEoG4X2EABG`
};
export default ___CSS_LOADER_EXPORT___;
